import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {Resource} from 'app/constants/resource';
import {IBin, Bin} from 'app/blocks/model/bin.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {BinService} from 'app/blocks/service/api/bin.service';

@Injectable({
    providedIn: 'root'
})
export class BinResource extends AbstractEntityResource<IBin> {
    constructor(binService: BinService, router: Router) {
        super(
            Resource.BINS,
            binService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.BINS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.BINS),
            (entity?) => new Bin(entity),
            (entity) => entity.id,
            'share'
        );
    }
}
